__turbopack_context__.v({
  "className": "noto_serif_558d21ce-module__JOHMGa__className",
  "variable": "noto_serif_558d21ce-module__JOHMGa__variable",
});
